import { TFunction } from "i18next";
import * as yup from "yup1";
import { FlowStepBaseSchema } from "../flow";

export const FlowStepTagSchema = (t: TFunction) =>
  FlowStepBaseSchema(t).shape({
    contact_tags: yup.array().nullable().of(yup.string()),
    conversation_tags: yup.array().nullable().of(yup.string()),
  });
